import React, { useState } from 'react';
import './style.scss';
import PaymentReceiptIcon from '../../../Assets/icons/PaymentReceiptIcon';
import ClockIcon from '../../../Assets/icons/ClockIcon';
import ElectricityIcon from '../../../Assets/icons/ElectricityIcon';
import InvoiceDownload from '../InvoiceDownload/InvoiceDownload';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import {
    downloadTopupInvoice,
    getChargingInvoice,
    getRefundInvoice,
    getTopupInvoice,
} from '../../../Views/AfterAuth/WalletView/redux/walletSlice';
import Reload from '../../../Assets/icons/Reload';
import PreLoader from '../../../Assets/icons/PreLoader/PreLoader';
import RefundInvoiceDownload from '../RefundInvoiceDownload/RefundInvoiceDownload';
import TopupInvoiceDownload from '../TopupInvoiceDownload/TopupInvoiceDownload';

const MyTransactioncard = ({
    amount,
    station,
    mode,
    lastChargingTime,
    element,
    check_invoice,
    transac_mode,
    txn_status,
    handleReload,
    transactionTime,
    requestedReloadPaymentId,
    paymentId,
    orderId,
    id,
    transaction,
}) => {
    const { walletTransactions } = useSelector((store) => store.wallet);

    const dispatch = useDispatch();
    const isReward =
        check_invoice === 'reward' &&
        transaction?.entry_type === 'credit';
    const amoun = amount.slice(0, 1);
    const [invoiceModal, setinvoiceModal] = useState(false);
    const [refundInvoiceModal, setRefundInvoiceModal] = useState(false);
    const [topupInvoiceModal, setTopupInvoiceModal] = useState(false);

    const invoiceOpen = () => {
        setinvoiceModal(true);
        dispatch(getChargingInvoice({ id: element }));
    };

    const invoiceClose = () => {
        setinvoiceModal(false);
    };

    /*Refund Invoice Download*/
    const refundInvoiceOpen = () => {
        setRefundInvoiceModal(true);
        dispatch(getRefundInvoice({ id: id }));
    };
    const refundInvoiceClose = () => {
        setRefundInvoiceModal(false);
    };

    /*Topup Invoice Download*/

    const topupInvoiceOpen = () => {
        setTopupInvoiceModal(true);
        dispatch(getTopupInvoice({ id: id }));
    };
    const topupInvoiceClose = () => {
        setTopupInvoiceModal(false);
    };

    const transactionStatus = () => {
        switch (true) {
            case txn_status?.toLowerCase() === 'failure':
            case check_invoice?.toLowerCase() !== 'topup' && !isReward:
                return 'send';
            case txn_status?.toLowerCase() === 'pending':
            case txn_status?.toLowerCase() === 'initiated':
                return 'pending';
            default:
                return 'received';
        }
    };
    return (
        <div>
            <div className="main-content">
                <div>
                    <div className="text">
                        <p>
                            {check_invoice?.toLowerCase() === 'topup'
                                ? txn_status?.toLowerCase() === 'failure'
                                    ? 'Failed to Add Wallet'
                                    : txn_status?.toLowerCase() === 'pending'
                                    ? 'Pending to Add Wallet'
                                    : txn_status?.toLowerCase() === 'initiated'
                                    ? 'Tried adding to wallet'
                                    : 'Added to Wallet'
                                : isReward
                                    ? 'Added to Reward Credits'
                                    : check_invoice?.toLowerCase() === 'refund'
                                        ? 'Refund'
                                        : station}
                        </p>
                        {/*it will show + only for reward and -₹ for amount detucted from wallet and + ₹ for topup*/}
                        <p className={transactionStatus()}>
                            {check_invoice?.toLowerCase() === 'topup'
                                ? ` +₹${amount}`
                                : isReward
                                ? ` +${amount}`
                                : ` -₹${amount}`}
                        </p>
                    </div>
                    <div className="time">
                        <span>
                            <ClockIcon />
                        </span>{' '}
                        <p>{dayjs(transactionTime).format('HH:mm a')}</p>
                        <span>
                            {!isReward && <ElectricityIcon />}
                        </span>
                        {transac_mode}
                        {/* <p>{mode}</p> */}
                    </div>
                </div>
                <div
                    style={{
                        cursor: 'pointer',
                        display: 'flex',
                        // gap: '10px',
                        alignItems: 'center',
                    }}
                    className="icon"
                >
                    {orderId && (
                        <div>
                            {txn_status?.toLowerCase() === 'pending' ||
                            txn_status?.toLowerCase() === 'initiated' ? (
                                <span onClick={handleReload}>
                                    {requestedReloadPaymentId === orderId ? (
                                        <PreLoader className="main-content--preloader" />
                                    ) : (
                                        <Reload />
                                    )}
                                </span>
                            ) : null}
                        </div>
                    )}

                    <div
                        onClick={() => {
                            if (check_invoice?.toLowerCase() === 'refund') {
                                refundInvoiceOpen();
                            } else if (check_invoice?.toLowerCase() === 'topup') {
                                topupInvoiceOpen();
                            } else {
                                invoiceOpen();
                            }
                        }}
                    >
                        {!isReward &&
                            (txn_status?.toLowerCase() === 'initiated' ? (
                                ' '
                            ) : (
                                <PaymentReceiptIcon />
                            ))}
                    </div>
                </div>
            </div>
            <InvoiceDownload
                element={element}
                openModal={invoiceModal}
                invoiceClose={invoiceClose}
            />
            {check_invoice?.toLowerCase() === 'refund' ? (
                <RefundInvoiceDownload
                    element={id}
                    openModal={refundInvoiceModal}
                    invoiceClose={refundInvoiceClose}
                />
            ) : check_invoice?.toLowerCase() === 'topup' ? (
                <TopupInvoiceDownload
                    element={id}
                    openModal={topupInvoiceModal}
                    invoiceClose={topupInvoiceClose}
                />
            ) : (
                ''
            )}
        </div>
    );
};
export default MyTransactioncard;
